// @flow
import type { AppState } from '../../core/types';
import { compose, withPropsOnChange, withProps, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import withEntity from '../../context/with-entity';
import ItemDetail from '../../ui/views/item-detail';
import { getCharitySelector } from '../charity/selectors';
import { domains } from '../constants';
import { t } from '../../core/i18n';
import { openItemDetailModal, closeItemDetailModal } from './actions';
import { isItemDetailModalOpen, getItemModalType } from './selectors';
import { ITEM_DETAIL_MODAL_TYPE } from './constants';
import { getItem } from '../index';
import withResetModal from '../modal/withResetModal';
import withAuctionCountdown from '../auction/withAuctionCountdown';

const withDomain = withProps(
  (props: Object): Object => ({
    domain: domains.ITEMS
  })
);

const mapStateToProps = (state: AppState, props: Object): Object => {
  const { match, entity } = props;
  const itemId = match.params.id;
  const item = entity || (itemId && getItem(itemId)(state));
  const charityId = item && item.auction && item.auction.charityId;
  const charity = charityId && getCharitySelector(charityId)(state);
  const isModalOpen = isItemDetailModalOpen(state);
  const modalType = getItemModalType(state);
  return {
    itemId,
    item,
    auction: item.auction,
    charityId,
    charity,
    isModalOpen,
    modalType
  };
};
const withItemAndCharityData = connect(
  mapStateToProps,
  {
    openItemDetailModal,
    closeItemDetailModal
  }
);

const withModalActions = withHandlers({
  openInstructions: props => e => {
    e.preventDefault();
    props.openItemDetailModal(
      ITEM_DETAIL_MODAL_TYPE.INSTRUCTIONS,
      props.itemId
    );
  },
  openQR: props => e => {
    e.preventDefault();
    props.openItemDetailModal(ITEM_DETAIL_MODAL_TYPE.QR, props.itemId);
  },
  openBidHistory: props => e => {
    e.preventDefault();
    props.openItemDetailModal(ITEM_DETAIL_MODAL_TYPE.BID_HISTORY, props.itemId);
  },
  openAboutShipping: props => e => {
    e.preventDefault();
    props.openItemDetailModal(
      ITEM_DETAIL_MODAL_TYPE.ABOUT_SHIPPING,
      props.itemId
    );
  },
  openQuestions: props => e => {
    e.preventDefault();
    props.openItemDetailModal(ITEM_DETAIL_MODAL_TYPE.QUESTIONS, props.itemId);
  },
  openHowToBid: props => e => {
    e.preventDefault();
    props.openItemDetailModal(ITEM_DETAIL_MODAL_TYPE.HOW_TO_BID, props.itemId);
  },
  closeModal: props => e => {
    e && e.preventDefault();
    props.closeItemDetailModal();
  }
});

const withTranslationsAndAuctionLink = withProps(props => ({
  translations: {
    itemNumber: t('item.properties.itemNumber'),
    charity: t('item.properties.charity'),
    donor: t('item.properties.donor'),
    finalBid: t('item.bids.final'),
    description: t('common:description'),
    locationAndDate: t('item.properties.location'),
    instructions: t('item.properties.instructions'),
    qrCode: t('item.properties.qrCode'),
    bids: t('item.properties.bids'),
    aboutShipping: t('item.info.aboutShipping'),
    question: t('item.info.question'),
    bidding: t('item.info.bidding')
  },
  auctionLink: `/auctions/${props.auction.id}`
}));

export const ItemDetailEnhancer = compose(
  withDomain,
  withEntity,
  withPropsOnChange(['entity', 'userId'], props => ({
    bidState: props.entity.bidState,
    currentBid: props.entity.currentBid
  })),
  withItemAndCharityData,
  withModalActions,
  withResetModal,
  withTranslationsAndAuctionLink,
  withAuctionCountdown
);

export default ItemDetailEnhancer(ItemDetail);



// WEBPACK FOOTER //
// ./src/services/item/ItemDetail.js